import { render, staticRenderFns } from "./navegacao-v2-shell.vue?vue&type=template&id=09e59f14&scoped=true&"
import script from "./navegacao-v2-shell.vue?vue&type=script&lang=js&"
export * from "./navegacao-v2-shell.vue?vue&type=script&lang=js&"
import style0 from "./navegacao-v2-shell.vue?vue&type=style&index=0&id=09e59f14&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e59f14",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e59f14')) {
      api.createRecord('09e59f14', component.options)
    } else {
      api.reload('09e59f14', component.options)
    }
    module.hot.accept("./navegacao-v2-shell.vue?vue&type=template&id=09e59f14&scoped=true&", function () {
      api.rerender('09e59f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/navegacao-v2-shell.vue"
export default component.exports